import { render, staticRenderFns } from "./FuneralInformations.vue?vue&type=template&id=74ed2dae&scoped=true"
import script from "./FuneralInformations.vue?vue&type=script&lang=js"
export * from "./FuneralInformations.vue?vue&type=script&lang=js"
import style0 from "./FuneralInformations.vue?vue&type=style&index=0&id=74ed2dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ed2dae",
  null
  
)

export default component.exports